import Http from '@/services/index.js'
import Model from '@/services/Model.js'

class Wallets extends Model {
  constructor() {
    super('/wallets/')
  }

  list(filter = '', config = {}) {
    return Http.get(`${this.model}list_wallets/${filter}`, config)
  }

  createWallet(payload, config = {}) {
    return Http.post(`${this.model}create_wallet/`, payload, config)
  }

  updateWallet(id, payload, config = {}) {
    return Http.patch(`${this.model}${id}/update_wallet/`, payload, config)
  }

  updateWalletStatus(id, active) {
    return Http.post(`${this.model}${id}/update_wallet_status/`, { active })
  }

  delete(payload) {
    return Http.post(`${this.model}delete_wallet/`, { wallet: payload })
  }
}

export default new Wallets()
